module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAIVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkTdLkSEPECwAAAAC3RSTlMAEIDv/wDPIDBAn2fwrtEAAAEoSURBVHjazdjBDoMgEEVRgUFr//+Dm7Ymt7sbzFt0dgqeRAw4M9t/RuujavS5Gr/Pbe/rvT6xtzWH5y6oV61LOFX9gkaJJE6NL3RUrUg4BJBI4hSvJpI4g8VelHBYbG4jLTr7vCCR1GkXZJI7QCKJAySSOEAiiQOkkjhAMskdIJdkApBLMrzJVB0EEsmGgERyB0gkcYBMEgdIJXGAVBIHyCRxgEwSB8gkd4BcwnHIJRyHkNRxCMkdIJdw0lD+1fKLnf/87iDltkhu0+aOkeDBlj9q84e/OyLFf5DuuBRIIlJpTS7RCqZ++WTUHZHSCbs7LoWLGndcihV+sVI0XBw/UuX6mWogzAq1NOYz0GTJtn1me1bV6O1mI6r9btrzMW/FcbBpA/GX0AtSQ1ntHSrXVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/274c.png
// module id = 1402
// module chunks = 0